import { getAccessibilityAccommodationsFormFieldsSchema } from "./AccessibilityAccommodationsFormFields";
import { getAnimalAssistanceFormFieldSchema } from "./AnimalAssistanceFormField";
import { getOtherAssistanceFormFieldsSchema } from "./OtherAssistanceFormFields";
import { getPersonalWheelchairAssistanceFormFieldsSchema } from "./PersonalWheelchairAssistanceFormFields";
import { getWheelchairAssistanceFormFieldSchema } from "./WheelchairAssistanceFormField";

export const getPassengerAccommodationsFormFieldsSchema = (fieldNames = {}) => {
  const {
    animalAssistanceFieldNames,
    accessibilityAccommodationsFieldNames,
    otherAssistanceFieldNames,
    personalWheelchairAssistanceFieldNames,
    wheelchairAssistanceFieldNames,
  } = fieldNames;

  return {
    ...getAnimalAssistanceFormFieldSchema(animalAssistanceFieldNames),
    ...getAccessibilityAccommodationsFormFieldsSchema(accessibilityAccommodationsFieldNames),
    ...getOtherAssistanceFormFieldsSchema(otherAssistanceFieldNames),
    ...getPersonalWheelchairAssistanceFormFieldsSchema(personalWheelchairAssistanceFieldNames),
    ...getWheelchairAssistanceFormFieldSchema(wheelchairAssistanceFieldNames),
  };
};
